import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-工程管理_钻井设计修订",
  "use": "icon-工程管理_钻井设计修订-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-工程管理_钻井设计修订\">\n<polygon points=\"11.4,10.6 12.2,9.8 10.7,4.9 8.1,4.9 8.1,3.7 10.3,2.2 10.3,2.2 10.3,2.2 7.1,0.2 7.1,1.7 7.1,1.7 7.1,4.9 4.5,4.9 \n\t1,15.8 2.1,15.8 5.3,5.9 10,5.9 \" />\n<path d=\"M13.5,9.5L9,13.9l-0.3,1.6l1.7-0.2l4.5-4.4L13.5,9.5z M10.3,14.9L9.4,15l0.1-0.8l4-4l0.7,0.8L10.3,14.9z\" />\n<rect x=\"11.1\" y=\"15.3\" width=\"3.7\" height=\"0.5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol